
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ResultCreerUtilisateursTenantSSOModel } from 'src/models/pilotage/resultCreerUtilisateurTenantSSOModel';

@Component({
    selector: 'app-confirmation-creation-utilisateur-dialog',
    templateUrl: './confirmation-creation-utilisateur-dialog.component.html',
    styleUrls: ['./confirmation-creation-utilisateur-dialog.component.scss'],
    imports: [MatDialogModule, TranslateModule]
})
export class ConfirmationCreationUtilisateurDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmationCreationUtilisateurDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResultCreerUtilisateursTenantSSOModel
  ) { }

  ngOnInit(): void {
  }

}
